var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],class:( _obj = {}, _obj[_vm.blok.style] = true, _obj ),style:(_vm.style)},[_vm._v("\n  "+_vm._s(_vm.blok.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }